import Vue from 'vue'
import VueRouter from 'vue-router'
import utils from "@/utils";
import constant from '@/constant';
import axios from 'axios'

Vue.use(VueRouter)

function loggedIn(to, from, next) {
  const token = localStorage.getItem('token');
  const user_type = localStorage.getItem('user_type');
  const app_url = localStorage.getItem('app');

  if (to.path === '/login') {
    
    // If the user is on the login page and there is a token, redirect to dashboard or current page
    if (token) {
      // add here checking if token is valid by using it in a request (change this to a proper endpoint this is just for testing)
      if (user_type == 'retail_admin'){
        next('/admin/dashboard')
      } else if (user_type == 'company_admin') {
        const tokenExp = localStorage.getItem('token_exp');

        if (tokenExp <= Date.now()) {
          // IF TOKEN IS EXPIRED
          localStorage.clear(); // CLEAR STORAGE
          axios.post(utils._api(constant.logout), {}, {
            withCredentials: true,
            headers: {
              Accept: "application/json",
              'X-Skip-Token-Refresh': 'true'  // SKIP AXIOS INTERCEPTOR FOR THIS REQUEST
            },
          }).then(() => {
            window.location.href = '/login'; // REDIRECT TO LOGIN PAGE
          }).catch(() => {
            window.location.href = '/login'; // REDIRECT TO LOGIN PAGE
          });
        } else {
          // IF TOKEN STILL VALID
          window.location.href = `${app_url}auth-redirect?token=${token}`;
          // window.location.href = app_url + 'dashboard';
   
        }
      } else {
        
        const tokenExp = localStorage.getItem('token_exp');

        if (tokenExp <= Date.now()) {
          // IF TOKEN IS EXPIRED
          localStorage.clear(); // CLEAR STORAGE
          axios.post(utils._api(constant.logout), {}, {
            withCredentials: true,
            headers: {
              Accept: "application/json",
              'X-Skip-Token-Refresh': 'true'  // SKIP AXIOS INTERCEPTOR FOR THIS REQUEST
            },
          }).then(() => {
            window.location.href = '/login'; // REDIRECT TO LOGIN PAGE
          }).catch(() => {
            window.location.href = '/login'; // REDIRECT TO LOGIN PAGE
          });
        } else {
          // IF TOKEN STILL VALID
          window.location.href = `${app_url}auth-redirect?token=${token}`;
          // window.location.href = app_url + 'dashboard';
   
        }
      }
    } else {
      next()
    }
  } else {
    // If the user is not on the login page
    if (!token) {
      next('/login')
    } else {
      const allowedRoutes = {
        'retail_admin': [
          '/admin/dashboard', 
          '/admin/subscribers',
          '/admin/accounts/users',
          '/admin/accounts/admin',
          '/admin/accounts/admin/register',
          '/admin/subscribers/register',
          '/admin/subscribers/manage/', // note the trailing slash
          '/admin/history/payments',
          '/admin/history/billings',
          '/admin/history/systemlogs',
          '/admin/configuration/subscription',
          '/admin/configuration/project',
          '/admin/configuration/project/add',
          '/admin/configuration/user-access-management',
          '/admin/configuration/app-features',
          '/admin/configuration/app-features/add',
          '/admin/configuration/app-permissions',
          '/admin/logs/authentication',
          '/auth-redirect',
        ],

        'company_admin': [
          '/dashboard', 
          '/billings', 
          '/paypal/success', 
          '/paypal/cancel',
          '/auth-redirect',
        ],

        'user': [
          '/auth-redirect',
        ]
      }
      
      const allowed = allowedRoutes[user_type] || [];

      const isAllowed = allowed.some(path => to.path === path || to.path.startsWith(path));

      if (isAllowed) { // IF USER TYPE HAVE ACCESS TO ROUTES
        next()
      } else {
        // IF NOT ALLOWED REDIRECT TO THIS ROUTE
        if (user_type == 'retail_admin') { // IF RETAIL ADMIN
          next('/admin/dashboard')
        } else { // ELSE IF COMPANY ADMIN
          next('/dashboard')
        }
      }
    }
  }
}

const routes = [
  {
    path: '/',
    redirect: '/login' // Redirect to the login page
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login/login.vue'),
    beforeEnter: loggedIn
  },
  {
    path: '/auth-redirect',
    name: 'logout',
    component: () => import('../views/LogoutValidationPage.vue'),
    beforeEnter: loggedIn
  },
  {
    path: '/admin/dashboard',
    name: 'admin-dashboard',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/Dashboard.vue'),
    beforeEnter: loggedIn
  },
  {
    path: '/admin/subscribers',
    name: 'admin-subscribers',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/Subscriber/Subscribers.vue'),
    beforeEnter: loggedIn
  },
  {
    path: '/admin/accounts/users',
    name: 'admin-user-accounts',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/Accounts/User.vue'),
    beforeEnter: loggedIn
  },
  {
    path: '/admin/accounts/admin',
    name: 'admin-admin-accounts',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/Accounts/Admin/Admin.vue'),
    beforeEnter: loggedIn
  },
  {
    path: '/admin/accounts/admin/register',
    name: 'admin-admin-accounts-add',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/Accounts/Admin/addAdminAccount.vue'),
    beforeEnter: loggedIn
  },
  {
    path: '/admin/subscribers/register',
    name: 'admin-add-subscribers',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/Subscriber/addSubscriber.vue'),
    beforeEnter: loggedIn
  },
  {
    path: '/admin/subscribers/manage/:company_id',
    name: 'admin-manage-subscribers',
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/Subscriber/manageSubscriber.vue'),
    beforeEnter: loggedIn
  },
  {
    path: '/admin/history/payments',
    name: 'admin-history-payments',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/Payment.vue'),
    beforeEnter: loggedIn
  },
  {
    path: '/admin/history/billings',
    name: 'admin-history-billings',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/Billings.vue'),
    beforeEnter: loggedIn
  },
  // {
  //   path: '/admin/history/systemlogs',
  //   name: 'admin-history-systemlogs',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/Admin/Systemlogs.vue'),
  //   beforeEnter: loggedIn
  // },
  {
    path: '/admin/configuration/subscription',
    name: 'admin-config-subscription',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/Configuration/Subscription/Subscription.vue'),
    beforeEnter: loggedIn
  },
  {
    path: '/admin/configuration/project',
    name: 'admin-config-project',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/Configuration/Project/Project.vue'),
    beforeEnter: loggedIn
  },
  {
    path: '/admin/configuration/project/add',
    name: 'admin-config-project-add',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/Configuration/Project/addProjectConfiguration.vue'),
    beforeEnter: loggedIn
  },
  {
    path: '/admin/configuration/user-access-management',
    name: 'admin-manage-role-access',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/Configuration/Roleandaccess/Userrole.vue'),
    beforeEnter: loggedIn
  },
  {
    path: '/admin/configuration/app-features',
    name: 'admin-app-features',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/Configuration/Appfeatures/Appfeatures.vue'),
    beforeEnter: loggedIn
  },
  {
    path: '/admin/configuration/app-features/add',
    name: 'admin-app-features-add',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/Configuration/Appfeatures/addAppFeature.vue'),
    beforeEnter: loggedIn
  },
  {
    path: '/admin/configuration/app-permissions',
    name: 'admin-app-permissions',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/Configuration/Apppermission/Apppermissions.vue'),
    beforeEnter: loggedIn
  },
  {
    path: '/dashboard',
    name: 'user-dashboard',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/User/Dashboard.vue'),
    beforeEnter: loggedIn
  },
  {
    path: '/billings',
    name: 'user-billings',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/User/Billings.vue'),
    beforeEnter: loggedIn
  },
  {
    path: '/paypal/success',
    name: 'paypal-success',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/User/Payment/Paypal/paypalSuccess.vue'),
    beforeEnter: loggedIn
  },
  {
    path: '/payment/result',
    name: 'payment-result',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/User/Payment/Dragonpay/DragonpayReturn.vue'),
    // beforeEnter: loggedIn
  },
  {
    path: '/paypal/cancel',
    name: 'paypal-cancel',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/User/Payment/Paypal/paypalCancel.vue'),
    beforeEnter: loggedIn
  },
  {
    path: '/maintenance',
    name: 'Maintenance',
    component: () => import('@/views/MaintenancePage.vue')
  },
  {
    path: '/admin/logs/authentication',
    name: 'admin-logs-authentication',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/Logs/AuthenticationLogs.vue'),
    beforeEnter: loggedIn
  },
  // {
  //   path: '/admin/accounts/admin',
  //   name: 'admin-admins',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/Admin/Accounts/Admin.vue')
  // },
  // {
  //   path: '/admin/payment',
  //   name: 'admin-payment',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/Admin/Payment.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})



export default router
